import { Typography } from '@material-ui/core';
import { tipoCargoDescriptions } from 'common/genericDescriptions';
import { Perfil, UsuarioParticipante } from 'common/genericTypes';
import { Section, SmSpace } from 'm2m.components';
import React from 'react';
import { addCpfCnpjMask } from 'utils/mask';

interface Props {
  usuarioMaster: UsuarioParticipante;
}

export const UsuarioMaster: React.FC<Props> = (props) => {
  const { usuarioMaster } = props;

  return (
    <>
      <Section title={usuarioMaster.perfil === Perfil.Master ? 'Usuário Master'
        : usuarioMaster.perfil === Perfil.Escrita ? 'Usuário Escrita'
          : usuarioMaster.perfil === Perfil.Leitura ? 'Usuário Leitura' : ''}>
        <div>
          <Typography variant="body2">{'Nome:'}</Typography>
          <Typography variant="body1">{usuarioMaster.nome}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'E-mail:'}</Typography>
          <Typography variant="body1">{usuarioMaster.email}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Perfil:'}</Typography>
          <Typography variant="body1">{usuarioMaster.perfil}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'CPF:'}</Typography>
          <Typography variant="body1">{usuarioMaster.cpf}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Convite aceito:'}</Typography>
          <Typography variant="body1">{usuarioMaster.conviteAceito ? 'Sim': 'Não'}</Typography>
          <SmSpace />
        </div>
      </Section>
    </>
  );
};

export default UsuarioMaster;
